import { useContext } from 'react';
import { AngularContext } from 'react-app';
import t from 'react-translate';

import { css } from '@emotion/react';
import { largeSpacing } from 'styles/global_defaults/scaffolding';

import { Button } from 'react-bootstrap';
import NvModal, { ModalType, BackdropType } from 'shared/components/nv-modal';
import { config } from '@config/pendo.config.json';

const styles = css`
  .bs4-modal-dialog {
    background-color: rgba(29, 33, 38, 0.8);
  }
  .bs4-modal-body {
    padding: ${largeSpacing}px;
  }
  .bs4-modal-footer {
    justify-content: center;
  }
`;

type ReachingYourLimitModalProps = {
  limit: number;
  onCancel: () => void;
  onContinue: () => void;
};

const ReachingYourLimitModal = (props: ReachingYourLimitModalProps) => {
  const { limit, onCancel, onContinue } = props;
  const translationBase = t.MENTORING_PROGRAMS.PARTICIPANT_HOME.MENTOR_REQUEST_MODAL.MENTOR_VIEW.REACHING_YOUR_LIMIT_MODAL;

  const { injectServices } = useContext(AngularContext);
  const [$state] = injectServices(['$state']);

  const profileSettingsLink = $state.href('mentoring-program-single-connection', {
    showProfile: true,
    mentorRequest: undefined,
    source: undefined,
  }, {
    absolute: true,
  });

  const dataQATag = config.pendo.athena.mentorshipProgram.participantHome.mentorRequest.modal.mentor.reachingYourLimitModal;

  return (
    <NvModal
      show
      type={ModalType.FIXED}
      modalStyles={styles}
      backdrop={BackdropType.DARK}
      doubleModal
      onClose={onCancel}
      header={translationBase.HEADER()}
      body={
        <div className='text-large-body'>
          {translationBase.BODY(
            limit.toString(),
            profileSettingsLink,
          )}
        </div>
      }
      footer={
        <div className='d-flex mt-4'>
          <Button
            size='lg'
            variant='secondary'
            className='mr-3'
            onClick={onCancel}
            data-qa={dataQATag.cancelButton}
          >
            {translationBase.FOOTER.CANCEL()}
          </Button>
          <Button
            size='lg'
            variant='primary'
            onClick={onContinue}
            data-qa={dataQATag.continueButton}
          >
            {translationBase.FOOTER.CONTINUE()}
          </Button>
        </div>
      }
      closeDataQa={dataQATag.closeButton}
    />
  );
};

export default ReachingYourLimitModal;
